import { useEffect } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useQueryRoleId } from './roleHook';
import { replace, push, useRouteMatch } from '../../app/route';
import {
  getRoleListUrl,
  getRoleDetailUrl,
  CreateRoleActionResponse,
  UpdateRoleActionResponse,
} from './roleSlice';
import { selectCurrentTenantId } from '../user/userSlice';
import { RoleCreateForm } from './RoleCreateForm';
import { RoleEditForm } from './RoleEditForm';
import { RoleView } from './RoleView';

type PathParams = {
  mode: 'view'|'edit'|'create';
  tenant_id: string;
};

export function RolePage() {
  const dispatch = useAppDispatch();
  const match = useRouteMatch<PathParams>();
  const { mode } = match.params;
  const role_id = useQueryRoleId();
  const tenant_id = useAppSelector(selectCurrentTenantId);

  useEffect(() => {
    if (['view', 'edit'].includes(mode) && !role_id) {
      dispatch(replace(getRoleListUrl(tenant_id)));
    }
  }, [dispatch, role_id, mode, tenant_id]);
  useEffect(() => {
    if (tenant_id !== match.params.tenant_id) {
      dispatch(push(getRoleListUrl(tenant_id)));
    }
  }, [tenant_id, dispatch, match.params.tenant_id]);

  const handleCreateCallback = (result: CreateRoleActionResponse) => {
    dispatch(push(getRoleDetailUrl(tenant_id, result.role_id, 'view')));
  };
  const handleUpdateCallback = (result: UpdateRoleActionResponse) => {
    dispatch(push(getRoleDetailUrl(tenant_id, role_id, 'view')));
  };
  const handleDismissCallback = (error?: SerializedError) => {
    if (error) {
      dispatch(push(getRoleListUrl(tenant_id)));
    } else if (mode === 'create') {
      dispatch(push(getRoleListUrl(tenant_id)));
    } else if (mode === 'edit' || mode === 'view') {
      dispatch(push(getRoleDetailUrl(tenant_id, role_id, 'view')));
    }
  };
  const handleGoEdit = () => {
    dispatch(push(getRoleDetailUrl(tenant_id, role_id, 'edit')));
  };
  const handleGoBack = () => {
    dispatch(push(getRoleListUrl(tenant_id)));
  };
  return (
    <div className="container">
      <div className="d-flex justify-content-between py-4">
        { mode === 'create' && <h1>Create Role</h1> }
        { mode === 'edit' && <h1>Edit Role</h1> }
        { mode === 'view' && <h1>View Role</h1> }
        { mode === 'view' && 
          <div className="btn-group" role="group">
            <button className="btn btn-outline-primary my-2" onClick={handleGoBack}>
              GoBack
            </button>
            <button className="btn btn-outline-primary my-2" onClick={handleGoEdit}>
              Edit
            </button>
          </div>
        }
      </div>
      { mode === 'create' && 
        <RoleCreateForm
          tenant_id={tenant_id}
          successCallback={handleCreateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'edit' && 
        <RoleEditForm
          tenant_id={tenant_id}
          role_id={role_id}
          successCallback={handleUpdateCallback}
          dismissCallback={handleDismissCallback}
        />
      }
      { mode === 'view' &&
        <RoleView
          tenant_id={tenant_id}
          role_id={role_id}
          closeCallback={handleDismissCallback}
        />
      }
    </div>
  );
}
